import { EnvironmentUrls, GameLauncher } from "Roblox";
import angular from "angular";
import chatModule from '../chatModule';

function gameService(chatUtility, httpService, $log, $q, apiParamsInitialization, gameParameters, gameLayout, urlService, $filter) {
    "ngInject";

    var apiSets = {};

    function multiGetGameIcons(imageTokens) {
        var params = {
            imageTokens: imageTokens,
            width: apiParamsInitialization.gameIconSize.lg.width,
            height: apiParamsInitialization.gameIconSize.lg.height
        }
        var result = {};

        return httpService.httpGet(apiSets["multiGetGameIcons"], params)
            .then(function (gameIcons) {
                if (gameIcons && gameIcons.length > 0) {

                    var retryTokens = [];
                    gameIcons.forEach(function (gameIcon) {
                        if (gameIcon) {
                            if (gameIcon.final) {
                                result[gameIcon.placeId] = gameIcon.url;
                            }
                            else {
                                if (gameIcon.retryToken) {
                                    retryTokens.push(gameIcon.retryToken);
                                }
                            }
                        }
                    });


                    // retry game icons without urls
                    if (retryTokens.length > 0) {
                        var params = {
                            imageTokens: retryTokens,
                            width: apiParamsInitialization.gameIconSize.lg.width,
                            height: apiParamsInitialization.gameIconSize.lg.height
                        }

                        httpService.httpGet(apiSets["multiGetGameIcons"], params)
                            .then(function (gameIcons) {
                                if (gameIcons && gameIcons.length > 0) {
                                    data.forEach(function (gameIcon) {
                                        if (gameIcon && gameIcon.final) {
                                            result[gameIcon.placeId] = gameIcon.url;
                                        }
                                    });
                                }
                            });
                    }
                    return result;
                }
                return null;
            }, function () {
                return null;
            });
    };

    function multiGetPlaceDetails(placeIds) {
        var params = { placeIds: placeIds };
        return httpService.httpGet(apiSets["multiGetPlaceDetails"], params).then(
            function success(placeDetails) {
                var imageTokens = [];
                var placeDetailDict = {};
                angular.forEach(placeDetails, function (placeDetail) {
                    if (placeDetail && placeDetail.imageToken) {
                        imageTokens.push(placeDetail.imageToken);
                    }
                    placeDetailDict[placeDetail.placeId] = placeDetail;
                });
                return multiGetGameIcons(imageTokens).then(function (gameIcons) {
                    angular.forEach(gameIcons, function (gameIconUrl, placeId) {
                        if (gameIconUrl) {
                            placeDetailDict[placeId].gameIconUrl = gameIconUrl;
                        }
                    });
                    return placeDetailDict;
                });
            }
        );
    }

    function multiGetPlaceDetailsForLinkCard(placeIds, getPlaceForMessages) {
        var params = { placeIds: placeIds };
        return httpService.httpGet(apiSets["multiGetPlaceDetails"], params).then(function (placeDetails) {
            if (placeDetails && placeDetails.length > 0) {
                var result = {};

                placeDetails.forEach(function (placeDetail) {
                    result[placeDetail.placeId] = placeDetail;
                });

                var inValidPlaceIds = [];
                placeIds.forEach(function (placeId) {
                    if (!result[placeId]) {
                        result[placeId] = null;
                        inValidPlaceIds.push(placeId);
                    }
                });
                getPlaceForMessages.forEach(function (message) {
                    if (message && message.linkCardMessages) {
                        message.linkCardMessages.forEach(function (pieceOfMessage) {
                            if (pieceOfMessage.isCard && inValidPlaceIds.indexOf(pieceOfMessage.id) > -1) {
                                pieceOfMessage.isCard = false;
                            }
                        });
                    }
                });
                return result;
            }
        });
    }

    function addGameIconUrlsToPlacesLibrary(chatLibrary, gameIcons) {
        angular.forEach(gameIcons, function (gameIconUrl, placeId) {
            if (gameIconUrl) {
                chatLibrary.placesLibrary[placeId].gameIconUrl = gameIconUrl;
                var place = chatLibrary.placesLibrary[placeId];
                chatLibrary.universeLibrary[place.universeId] = place;
            }
        });
    }

    function buildPlacesLibrary(chatLibrary, placeDetailsData, messageDictByPlaceIds) {
        angular.forEach(placeDetailsData, function (placeDetail, placeId) {
            if (placeDetail) {
                var originalPlaceData;
                if (chatLibrary.placesLibrary[placeId]) {
                    originalPlaceData = chatLibrary.placesLibrary[placeId];
                }
                var creatorName = placeDetail.creatorName ? placeDetail.creatorName : placeDetail.builder;
                chatLibrary.placesLibrary[placeId] = {
                    universeId: placeDetail.universeId,
                    placeId: placeId,
                    rootPlaceId: placeDetail.universeRootPlaceId || placeDetail.placeId || placeDetail.rootPlaceId,
                    placeName: placeDetail.name,
                    encodedPlaceName: chatUtility.htmlEntities(placeDetail.name),
                    creatorName: creatorName,
                    encodedCreatorName: chatUtility.htmlEntities(creatorName),
                    creatorId: placeDetail.creatorId || placeDetail.builderId,
                    gameIconUrl: placeDetail.gameIconUrl,
                    placeUrl: placeDetail.url || placeDetail.placeUrl,
                    reasonProhibited: placeDetail.reasonProhibited,
                    description: placeDetail.description,
                    price: placeDetail.price,
                    isPlayable: placeDetail.isPlayable,
                    gameReferralUrl: placeDetail.gameReferralUrl
                }

                if (originalPlaceData) { // avoid existing place key/value from overriding
                    angular.forEach(originalPlaceData, function (value, key) {
                        if (!chatLibrary.placesLibrary[placeId][key]) {
                            chatLibrary.placesLibrary[placeId][key] = value;
                        }
                    });
                }

                if (placeDetail.reasonProhibited) {
                    switch (placeDetail.reasonProhibited) {
                        case gameParameters.reasonProhibitedMessage.None:
                        case gameParameters.reasonProhibitedMessage.Playable:
                            chatLibrary.placesLibrary[placeId].buttonLayoutForLinkCard = angular.copy(gameLayout.playButtons.play);
                            break;
                        case gameParameters.reasonProhibitedMessage.PurchaseRequired:
                            chatLibrary.placesLibrary[placeId].buttonLayoutForLinkCard = angular.copy(gameLayout.playButtons.details);
                            break;
                        default:
                            chatLibrary.placesLibrary[placeId].buttonLayoutForLinkCard = angular.copy(gameLayout.playButtons.details);
                            break;
                    }
                }
                // transfer to use universeLibrary
                chatLibrary.universeLibrary[placeDetail.universeId] = chatLibrary.placesLibrary[placeId];
            } else if (!placeDetail && chatLibrary.placesLibrary[placeId]) {
                chatLibrary.placesLibrary[placeId] = {
                    isInvalid: true
                };
                if (messageDictByPlaceIds) {
                    chatUtility.invalidateLinkCardInPieceOfMessage(placeId, messageDictByPlaceIds);
                }
            }

        });
    }

    function invalidatePlaceDetails(chatLibrary, placeIds) {
        placeIds.forEach(function (placeId) {
            if (!chatLibrary.placesLibrary[placeId]) {
                chatLibrary.placesLibrary[placeId] = {};
            }
            chatLibrary.placesLibrary[placeId] = {
                isInvalid: true
            };
        });
    }

    function buildRegularPlaceUrl(place) {
        var gameUrl = urlService.getAbsoluteUrl(gameParameters.gameUrl);
        return $filter("formatString")(gameUrl, { placeId: place.placeId });
    }

    function buildGameReferralUrl(place, sortName) {
        var urls = urlService.getGameDetailReferralUrls();
        var urlInChatTemplate = urls.chat;
        return $filter("formatString")(urlInChatTemplate, { sortName: sortName, placeId: place.placeId });
    }

    function getGameIcons(universeIds) {
        return httpService.buildBatchPromises(apiSets["GetGamesIcons"], universeIds, gameParameters.gameIconMultiGetLimit, "universeIds")
            .then(function (result) {
                if (result && result.length > 0) {
                    var gameIcons = [];
                    angular.forEach(result, function (item) {
                        gameIcons = gameIcons.concat(item.data);
                    });
                    return gameIcons;
                }
            });
    }

    return {
        apiSets: apiSets,

        setParams: function (chatApiDomain, gameApiDomain) {
            apiSets["setConversationUniverse"] = { url: chatApiDomain + apiParamsInitialization.chatUrls.setConversationUniverse, retryable: false, withCredentials: true }
            apiSets["resetConversationUniverse"] = { url: chatApiDomain + apiParamsInitialization.chatUrls.resetConversationUniverse, retryable: false, withCredentials: true }
            apiSets["multiGetPlaceDetails"] = { url: gameApiDomain + apiParamsInitialization.gameUrls.multiGetPlaceDetails, retryable: true, withCredentials: true }
            apiSets["multiGetGameIcons"] = { url: gameApiDomain + apiParamsInitialization.gameUrls.multiGetGameIcons, retryable: true, withCredentials: true }
            apiSets["GetGamesSorts"] = { url: gameApiDomain + apiParamsInitialization.gameUrls.GetGamesSorts, retryable: true, withCredentials: true }
            apiSets["GetGamesList"] = { url: gameApiDomain + apiParamsInitialization.gameUrls.GetGamesList, retryable: true, withCredentials: true }
            apiSets["GetGamesIcons"] = { url: EnvironmentUrls.thumbnailsApi + apiParamsInitialization.thumbnailUrls.multiGetGameIcons, retryable: true, withCredentials: true }
            apiSets["getGamesByUniverseIds"] = { url: apiParamsInitialization.gameUrls.getGamesByUniverseIds, retryable: true, withCredentials: true }
            apiSets["multiGetPlayabilityStatus"] = { url: apiParamsInitialization.gameUrls.multiGetPlayabilityStatus, retryable: true, withCredentials: true }
        },

        setConversationUniverse: function (conversationId, universeId) {
            var data = {
                conversationId: conversationId,
                universeId: universeId
            }
            return httpService.httpPost(apiSets["setConversationUniverse"], data);
        },

        resetConversationUniverse: function (conversationId) {
            var data = {
                conversationId: conversationId
            }
            return httpService.httpPost(apiSets["resetConversationUniverse"], data);
        },

        multiGetPlaceDetailsForLinkCard: multiGetPlaceDetailsForLinkCard,

        multiGetPlaceDetails: multiGetPlaceDetails,

        multiGetGameIcons: multiGetGameIcons,

        playRegularGame: function (placeId, isPlayTogetherGame) {
            isPlayTogetherGame = isPlayTogetherGame === true;
            GameLauncher.joinMultiplayerGame(placeId, true, isPlayTogetherGame);
        },

        playTogetherGame: function (placeId, conversationId) {
            GameLauncher.playTogetherGame(placeId, conversationId);
        },

        joinGame: function (placeId, gameInstanceId) {
            GameLauncher.joinGameInstance(placeId, gameInstanceId, true, true);
        },

        playPrivateServerGame: function (placeId, privateServerLinkCode) {
            GameLauncher.joinPrivateGame(placeId, null, privateServerLinkCode);
        },

        fetchDataForLinkCard: function (messages, chatLibrary) {
            if (!messages) {
                return false;
            }
            var placeIds = []; // placeId does not exist in placesLibrary
            var messageDictByPlaceIds = {};
            var getPlaceForMessages = [];
            messages.forEach(function (message) {
                if (message.hasLinkCard) {
                    var linkCardMessages = message.linkCardMessages;
                    linkCardMessages.forEach(function (pieceOfMessage) {
                        if (pieceOfMessage.isCard) {
                            switch (pieceOfMessage.type) {
                                case chatUtility.linkCardTypes.gameCard:
                                    var placeId = pieceOfMessage.id;
                                    if (!chatUtility.isPlaceDetailQualifiedInLibrary(chatLibrary.placesLibrary, placeId)) {
                                        getPlaceForMessages.push(message);

                                        if (placeIds.indexOf(placeId) < 0) {
                                            placeIds.push(placeId);
                                            messageDictByPlaceIds[placeId] = message;
                                        }
                                    } else if (chatLibrary.placesLibrary[placeId] && chatLibrary.placesLibrary[placeId].isInvalid) {
                                        pieceOfMessage.isCard = false;
                                    }
                                    break;
                            }
                        }
                    });
                }
            });

            if (placeIds.length > 0) {
                multiGetPlaceDetailsForLinkCard(placeIds, getPlaceForMessages)
                    .then(function (placeDetails) {
                        if (!placeDetails) {
                            invalidatePlaceDetails(chatLibrary, placeIds);
                            chatUtility.invalidateLinkCardsInMessageDict(placeIds, messageDictByPlaceIds);
                            return false;
                        }
                        buildPlacesLibrary(chatLibrary, placeDetails, messageDictByPlaceIds);
                        var imageTokens = [];
                        angular.forEach(placeDetails, function (placeDetail) {
                            if (placeDetail && placeDetail.imageToken) {
                                imageTokens.push(placeDetail.imageToken);
                            }
                        });
                        multiGetGameIcons(imageTokens).then(function (gameIcons) {
                            addGameIconUrlsToPlacesLibrary(chatLibrary, gameIcons);
                        });
                    }, function () {
                        invalidatePlaceDetails(chatLibrary, placeIds);
                        chatUtility.invalidateLinkCardsInMessageDict(placeIds, messageDictByPlaceIds);
                    });
            }
        },

        updateButtonLayoutPerConversation: function (conversation, rootPlaceId) {
            if (!conversation.placeButtonLayout ||
                (conversation.placeButtonLayout && !conversation.placeButtonLayout[rootPlaceId].isPlayable)) {
                return false;
            }
            if (conversation.pinGame
                && conversation.playTogetherIds
                && conversation.playTogetherIds.indexOf(rootPlaceId) > -1) {
                conversation.placeButtonLayout[rootPlaceId] = angular.copy(gameLayout.playButtons.join);
            } else {
                conversation.placeButtonLayout[rootPlaceId] = angular.copy(gameLayout.playButtons.play);
            }
        },

        buildButtonLayoutPerConversation: function (conversation, placesLibrary) {
            var placeIds = [];
            var rootPlaceIdForPinGame = null;
            var isPinGameAnActiveGame = true;
            if (conversation.playTogetherIds && conversation.playTogetherIds.length > 0) {
                placeIds = angular.copy(conversation.playTogetherIds);
            }
            if (conversation.pinGame) {
                rootPlaceIdForPinGame = conversation.pinGame.rootPlaceId;
                if (placeIds.indexOf(rootPlaceIdForPinGame) < 0) {
                    isPinGameAnActiveGame = false;
                    placeIds.push(rootPlaceIdForPinGame);
                }
            }

            if (!conversation.placeButtonLayout) {
                conversation.placeButtonLayout = {};
            }
            angular.forEach(placeIds, function (placeId) {
                var placeDetails = placesLibrary[placeId];
                if (placeDetails) {
                    switch (placeDetails.reasonProhibited) {
                        case gameParameters.reasonProhibitedMessage.None:
                        case gameParameters.reasonProhibitedMessage.Playable:
                            if (!isPinGameAnActiveGame && placeId === rootPlaceIdForPinGame) {
                                conversation.placeButtonLayout[placeId] = angular.copy(gameLayout.playButtons.play);
                            } else {
                                conversation.placeButtonLayout[placeId] = angular.copy(gameLayout.playButtons.join);
                            }
                            break;
                        case gameParameters.reasonProhibitedMessage.PurchaseRequired:
                            conversation.placeButtonLayout[placeId] = angular.copy(gameLayout.playButtons.details);
                            break;
                        default:
                            conversation.placeButtonLayout[placeId] = angular.copy(gameLayout.playButtons.notAvailable);
                            break;
                    }
                }
            });
        },
        buildPlacesLibrary: buildPlacesLibrary,

        getGameIcons: getGameIcons,

        getRecentGame: function () {
            return httpService.httpGet(apiSets["GetGamesSorts"])
                .then(function success(result) {
                    if (result && result.sorts) {
                        var sorts = result.sorts;
                        var sortToken, sortName;
                        sorts.forEach(function (sort) {
                            if (sort.name === gameParameters.sortNames.myRecent) {
                                sortToken = sort.token;
                                sortName = sort.name;
                                return false;
                            }
                        });

                        if (sortToken) {
                            var params = {
                                sortToken: sortToken,
                                maxRows: gameParameters.maxRowsOfMyRecentGames
                            }
                            return httpService.httpGet(apiSets["GetGamesList"], params)
                                .then(function success(data) {
                                    if (data && data.games && data.games.length > 0) {
                                        var games = data.games;
                                        var universeIds = [];
                                        angular.forEach(games, function (place) {
                                            place.gameReferralUrl = buildGameReferralUrl(place, sortName);
                                            universeIds.push(place.universeId);
                                        });
                                        return games;
                                    }
                                });

                        };
                    }
                });
        },

        getGames: function (universeIds) {
            var params = {
                universeIds: universeIds
            };
            var promises = {};
            promises["getGamesInfo"] = httpService.httpGet(apiSets["getGamesByUniverseIds"], params);
            promises["getPlayabilityStatus"] = httpService.httpGet(apiSets["multiGetPlayabilityStatus"], params);
            return $q.all(promises)
                .then(function success(results) {
                    if (results && results["getGamesInfo"] && results["getPlayabilityStatus"]) {
                        var gameInfo = results["getGamesInfo"].data;
                        var playabilityStatus = results["getPlayabilityStatus"];
                        var placeLibrary = {};
                        var universeLibrary = {};
                        angular.forEach(gameInfo, function (game, idx) {
                            var placeId = game.rootPlaceId;
                            var universeId = playabilityStatus[idx].universeId;
                            placeLibrary[placeId] = game;
                            placeLibrary[placeId].universeId = universeId;
                            placeLibrary[placeId].placeId = placeId;
                            placeLibrary[placeId].isPlayable = playabilityStatus[idx].isPlayable;
                            placeLibrary[placeId].reasonProhibited = playabilityStatus[idx].playabilityStatus;
                            placeLibrary[placeId].placeUrl = buildRegularPlaceUrl(placeLibrary[placeId]);
                            universeLibrary[universeId] = placeLibrary[placeId];
                        });
                        return getGameIcons(universeIds)
                            .then(function success(gameIcons) {
                                if (gameIcons) {
                                    angular.forEach(gameIcons, function (gameIcon) {
                                        var universeId = gameIcon.targetId;
                                        universeLibrary[universeId].gameIconUrl = gameIcon.imageUrl;
                                        var placeId = universeLibrary[universeId].placeId;
                                        placeLibrary[placeId] = universeLibrary[universeId];
                                    });

                                    return placeLibrary;
                                }
                            });
                    }
                });
        }
    }
};

chatModule.factory("gameService", gameService);

export default gameService;